import React, { type Dispatch, type SetStateAction } from 'react';
import { Typography, Box, Paper } from '@mui/material';
import SystemAccordionList from '../SystemAccordionList';
import PlumbingSystemFields, { createDefaultPlumbingSystem } from '../PlumbingSystemFields';
import type { PlumbingSystemValues } from '../PlumbingSystemFields';
import MediaUploadSection from '../../../../sharedModules/mediaUpload/MediaUploadSection';
import type { ManufacturerOption } from '../../hooks/useHomeServiceManufacturers';
import { sectionHeaderSx } from './inspectionReportFormStyles';

interface PlumbingInspectionSectionProps {
  plumbingSystems: PlumbingSystemValues[];
  setPlumbingSystemsWithDirty: Dispatch<SetStateAction<PlumbingSystemValues[]>>;
  plumbingManufacturers: ManufacturerOption[];
  plumbingSystemPhotos: File[][];
  updateSystemMedia: (type: 'hvac' | 'plumbing', systemId: string, files: File[]) => Promise<void>;
  onSystemRemove: (systemId: string) => void;
}

const PlumbingInspectionSection: React.FC<PlumbingInspectionSectionProps> = ({
  plumbingSystems,
  setPlumbingSystemsWithDirty,
  plumbingManufacturers,
  plumbingSystemPhotos,
  updateSystemMedia,
  onSystemRemove,
}) => (
  <Paper variant="outlined" sx={{ mb: 3, overflow: 'hidden' }}>
    <Typography sx={sectionHeaderSx}>Plumbing</Typography>
    <Box sx={{ p: 2 }}>
      <SystemAccordionList<PlumbingSystemValues>
        sectionLabel="Plumbing"
        systems={plumbingSystems}
        onSystemsChange={setPlumbingSystemsWithDirty}
        createDefaultSystem={createDefaultPlumbingSystem}
        onSystemRemove={onSystemRemove}
        renderFields={(sys, idx, onChange) => (
          <>
            <PlumbingSystemFields values={sys} onChange={onChange} manufacturers={plumbingManufacturers} />
            <MediaUploadSection
              label={`Plumbing System ${idx + 1} Photos`}
              files={plumbingSystemPhotos[idx] || []}
              onChange={(files) => updateSystemMedia('plumbing', sys.id, files)}
            />
          </>
        )}
      />
    </Box>
  </Paper>
);

export default PlumbingInspectionSection;
